export default __webpack_public_path__ + "static/media/msg-ico-active.cece7e22.svg";